export const replaceTab = (...args) => $.frame.replace_tab(...args);
